import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../core/animations';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-create-admin',
  templateUrl: './create-admin.component.html',
  styleUrls: ['./create-admin.component.scss'],
  animations: fuseAnimations
})
export class CreateAdminComponent implements OnInit {
  form: FormGroup;
  formErrors: any;
  roles: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private afs: AngularFirestore) {


    this.formErrors = {
      username: {}
    };

  }
  ngOnInit() {
    this.roles = localStorage.getItem('currentUserRole');
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      role: ['']
    });
  }

  create(user) {
    if (!user) {
      return;
    }
    console.log(this.form.value.role)
    this.afs.collection('users').ref.where('username', '==', user.username).get().then(isUser => {
      if (!isUser.empty) {
        this.afs.collection('adminUsers').doc(isUser.docs[0].id).set({
          roles: this.form.value.role
        }).then(() => {
          this.form.reset();
          this.afs.collection('users').doc(isUser.docs[0].id).update({
            isAdmin: true
          })
        })
      }
      else {
        this.router.navigate(['/dashboard']);

      }
    })

  }
}




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/create-admin/create-admin.component.ts